import React from "react"
import { Button } from "@relume_io/relume-ui";

export default function ContactButton() {

    return(<Button
        title="Contact Us"
        variant="secondary"
        size="sm"
        className="rounded-[100px]"
        onClick={() => window.open("https://meetings-eu1.hubspot.com/matthias32/website", "_blank")}
      >
        Kontakt aufnehmen
      </Button>
      );
    
}
